<template>
  <v-tooltip
    v-if="!hideTooltip"
    location="left"
    :offset="8"
    content-class="show-all-tooltip">
    <template v-slot:activator="{ props: tooltipProps }">
      <div v-bind="tooltipProps" class="show-all-toggle">
        <v-checkbox
          :model-value="modelValue"
          hide-details
          density="compact"
          label="SHOW ALL"
          color="primary"
          class="ma-0 pa-0"
          @update:model-value="$emit('update:modelValue', $event)" />
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <div v-else class="show-all-toggle">
    <v-checkbox
      :model-value="modelValue"
      hide-details
      density="compact"
      label="SHOW ALL"
      color="primary"
      class="ma-0 pa-0"
      @update:model-value="$emit('update:modelValue', $event)" />
  </div>
</template>

<script>
export default {
  name: 'ShowAllToggle',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '모든 항목을 표시합니다',
    },
    hideTooltip: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style>
.show-all-tooltip {
  background: #1e293b !important;
  color: #f1f5f9 !important;
  font-size: 12px !important;
  padding: 5px 10px !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
  white-space: nowrap;
}
</style>

<style scoped>
.show-all-toggle {
  display: flex;
  align-items: center;
}
</style>
